module.exports = __webpack_public_path__ + "img/banner-one2.f2dbcbda.png";